import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ArService {

  url = environment.url;
  constructor(public http: HttpClient) { }

  // getDashboardData(stations, startDate, endDate) {
  //   let reqBody = {
  //     "startDate": startDate,
  //     "endDate": endDate,
  //     "stationId": stations
  //   }
  //   return this.http.post(`${this.url}` + '/retail/dashData', reqBody).pipe(tap(res => res),
  //     catchError(err => throwError(new Error('Issue in backend'))),
  //   );
  // }

  getUnAssignedTransactions(payload = {}) {
    return this.http.post(`${this.url}` + '/retailBooking/getUnAssignedTransanctions', payload).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }
  getAllTransactions() {
    return this.http.get(`${this.url}` + '/retailBooking/getTransactionTable').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }


  getTransactionByResId(resId) {
    return this.http.get(`${this.url}` + '/retailBooking/getTransactionById/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in  backend'))),
    );
  }

  getInProgressTransactionByResId(resId) {
    return this.http.get(`${this.url}` + '/retailBooking/getInProgressTransactionByResId/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }



  getMultipleTransactionByResId(resId) {
    return this.http.get(`${this.url}` + '/retailBooking/getMultiTransactionDataByResId/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getMultipleTransactionByResId'))),
    );
  }

  getInvoiceData(resId) {
    return this.http.get(`${this.url}` + '/retailBooking/getInvoiceDataByResId/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getInvoiceData'))),
    );
  }

  getInvoicePassengersDataByResId(resId) {
    return this.http.get(`${this.url}` + '/retailBooking/getInvoicePassengersDataByResId/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getInvoicePassengersDataByResId'))),
    );
  }

  getAgenciesByStationId(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getAgenciesByStationId', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgenciesByStationId'))),
    );
  }

  getAllAgenciesByStationId(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getAllAgenciesByStationId', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAllAgenciesByStationId'))),
    );
  }

  getCustomersByStation(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getCustomersByStation', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getCustomersByStation'))),
    );
  }


  getCustomersByStationId(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getCustomersByStationId', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getCustomersByStation'))),
    );
  }

  getCustomersByStationAndCompany(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getCustomersByStationAndCompany', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getCustomersByStationAndCompany'))),
    );
  }

  getCustomers() {
    return this.http.get(`${this.url}` + '/retailBooking/getCustomers').pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in getting getCustomers'))),
    );
  }

  savePaymentsOfTransaction(data) {
    return this.http.post(`${this.url}` + '/retailBooking/savePaymentInfo', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting savePaymentsOfTransaction'))),
    );
  }

  updatePaymentsOfTransaction(data) {
    return this.http.post(`${this.url}` + '/retailBooking/updateTransactionAmount', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting contracts'))),
    );
  }
  creditCardPaymentsOfTransaction(data) {
    return this.http.post(`${this.url}` + '/retailBooking/paymentCCandCheque', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting creditCardPaymentsOfTransaction'))),
    );
  }

  profilePaymentsOfTransaction(data) {
    return this.http.post(`${this.url}` + '/retailBooking/markAndCaptureByProfileReference', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting markAndCaptureByProfileReference'))),
    );
  }

  updatePrintOfInvoice(data) {
    return this.http.post(`${this.url}` + '/retailBooking/updateInvoicePrint', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting updatePrintOfInvoice'))),
    );
  }

  getTaxSlabByStation(data) {
    return this.http.post(`${this.url}` + '/retailBooking/getTaxSlabByStation', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getTaxSlabByStation'))),
    );
  }

  // chequePaymentsOfTransaction(data){
  //   return this.http.post(`${this.url}` + '/retailBooking/savePaymentInfo',data).pipe(tap(res => res),
  //   catchError(err => throwError(new Error('Issue in getting contracts'))),
  // );
  // }


  getAllAssignedTransactions(payload = {}) {
    return this.http.post(`${this.url}` + '/retailBooking/getAssignedTransactions', payload).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAllAssignedTransactions'))),
    );
  }

  multiACTransactionForCC(data) {
    return this.http.post(`${this.url}` + '/retailBooking/multiACTransactionForCC', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting multiACTransactionForCC'))),
    );
  }

  getPaidTransactions(payload = {}) {
    return this.http.post(`${this.url}` + '/retailBooking/getPaidTransactions', payload).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getPaidTransactions'))),
    );
  }

  //addAdditionalService
  addAdditionalService(data) {
    return this.http.post(`${this.url}` + '/retailBooking/addAdditionalService', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting updatePrintOfInvoice'))),
    );
  }

  getAllCustomers(status: boolean[] = [true]) {
    const statusAsString: string[] = status.map(s => String(s));

    let params = new HttpParams();
    statusAsString.forEach(s => {
      params = params.append('status', s);
    });

    return this.http.get(`${this.url}/retailBooking/getAllCustomers`, { params }).pipe(
        tap(res => res),
        catchError(err => throwError(new Error('Issue in backend')))
    );
  }

  getAllAgencies() {
    return this.http.get(`${this.url}` + '/retailBooking/getAllAgencies').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getAllTaxPrices() {
    return this.http.get(`${this.url}` + '/retailBooking/getAllTaxPrices').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getAllstationsWithCode() {
    return this.http.get(`${this.url}` + '/attributes/stationsWithCode').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getAllAgenciesData() {
    return this.http.get(`${this.url}` + '/attributes/agenciesData').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getCustomerDataById(id) {
    return this.http.get(`${this.url}` + '/attributes/getCustomerDetailsByID/' + id).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getAgencyDataById(id) {
    return this.http.get(`${this.url}` + '/attributes/getAgencyDetailsByID/' + id).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  getTaxDataById(id) {
    return this.http.get(`${this.url}` + '/attributes/getTaxRatesDetailsByID/' + id).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  updateCustomerData(data) {
    return this.http.post(`${this.url}` + '/contractService/updateCustomer', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating customer data'))),
    );
  }

  updateAgencyData(data) {
    return this.http.post(`${this.url}` + '/contractService/updateAgency', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating Agency data'))),
    );
  }

  updateTaxData(data) {
    return this.http.post(`${this.url}` + '/contractService/updateTaxRate', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating Tax data'))),
    );
  }
  addCustomersData(data) {
    return this.http.post(`${this.url}` + '/contractService/insertCustomer', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in adding customer data'))),
    );
  }

  addAgencyData(data) {
    return this.http.post(`${this.url}` + '/contractService/insertAgency', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in adding Agency data'))),
    );
  }

  addTaxRatesData(data) {
    return this.http.post(`${this.url}` + '/contractService/insertTaxrates', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in adding Tax data'))),
    );
  }


  updateRetailWebRes(data) {
    return this.http.post(`${this.url}` + '/retailBooking/updateCCardPendingRes', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getCustomersByStation'))),
    );
  }

  getAllStations() {
    return this.http.get(`${this.url}` + '/attributes/getAllstations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  addStationsData(data) {
    return this.http.post(`${this.url}` + '/attributes/insertStation', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in adding Station data'))),
    );
  }

  getStationDataById(id) {
    return this.http.get(`${this.url}` + '/station/stations/' + id).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  updateStationData(data) {
    return this.http.post(`${this.url}` + '/attributes/updateStationById', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating station data'))),
    );
  }

  ManualClosurePayment(data) {
    return this.http.post(`${this.url}` + '/retailBooking/manualPaymentUpdate', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating payment reservation'))),
    );
  }

  getAllAirlineServices() {
    return this.http.get(`${this.url}` + '/attributes/airlines').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }

  updateAirlineData(data) {
    return this.http.post(`${this.url}` + '/attributes/insertairline', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in updating airline data'))),
    );
  }

}
